import React, { FC } from 'react'
import { styled, breakpointUp } from '@moonpig/launchpad-utils'
import { IconSystemArrowBack } from '@moonpig/launchpad-assets'
import { system as s } from '@moonpig/launchpad-system'
import { getSharedButtonStyles } from './getSharedButtonStyles'
import { useLocaleText } from '../locale'
import { ICON_SIZE_PX, SEARCH_FORM_Z_INDEX } from './constants'

const StyledBackButton = styled.button<{
  shouldDisplay: boolean
}>`
  ${getSharedButtonStyles()}
  z-index: ${SEARCH_FORM_Z_INDEX};
  border-bottom: 1px solid;
  display: ${({ shouldDisplay }) => (shouldDisplay ? 'flex' : 'none')};
  ${s({
    borderColor: 'colorBorder03',
    bgcolor: 'colorBackground01',
    paddingX: 4,
  })}

  ${breakpointUp('md')} {
    border-bottom: none;
    display: none;
  }
`

type BackButtonProps = {
  onClick: () => void
  shouldDisplay?: boolean
} & React.HTMLProps<HTMLInputElement>

export const BackButton: FC<React.PropsWithChildren<BackButtonProps>> = ({
  onClick,
  shouldDisplay = true,
}) => {
  const t = useLocaleText()
  return (
    <StyledBackButton
      data-testid="lp-nav-search-back-button"
      aria-label={t('search.close_search')}
      type="button"
      onClick={onClick}
      shouldDisplay={shouldDisplay}
    >
      <IconSystemArrowBack width={ICON_SIZE_PX} height={ICON_SIZE_PX} />
    </StyledBackButton>
  )
}
